export default __webpack_public_path__ + "img/sigle-blanc.png";